<template>
    <div>
      <div v-if="isSmallScreen"> 
        <MainBannerSmallScreen />
      </div>
      <div v-else>
        <MainBannerBigScreen />
      </div>
    </div>
  </template>
  
  <script>
  import MainBannerSmallScreen from './MainBannerSmallScreen.vue';
  import MainBannerBigScreen from './MainBannerBigScreen.vue';
  
  export default {
    components: {
        MainBannerSmallScreen,
        MainBannerBigScreen
    },
    computed: {
      isSmallScreen() {
        return window.innerWidth <= 1262;
      }
    },
    mounted() {
      if (this.isSmallScreen) {
        this.loadSmallScreenScripts();
      } else {
        this.loadLargeScreenScripts();
      }
    },
    methods: {
      loadSmallScreenScripts() {
        const script = document.createElement('script');
        
        script.async = true;
        document.head.appendChild(script);
      },
      loadLargeScreenScripts() {
        const script = document.createElement('script');
        
        script.async = true;
        document.head.appendChild(script);
      }
    }
  }
  </script>
  